import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useCodingProfileEdit = () => {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const editRequest = (
    guid,
    codeName,
    codePrefix,
    codeType,
    codeLogic,
    handleRefetch,
  ) => {
    setLoading(true);
    axiosClient
      .put(`SettingProduct/CoddingProfile/Update`, {
        guid,
        display: codeName,
        prefix: codePrefix,
        type: codeType,
        logic: codeLogic,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`ویرایش با موفقیت انجام شد`, { variant: 'success' });
          handleRefetch();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [editRequest, loading];
};

export default useCodingProfileEdit;
